import React from 'react'
import style from './style.module.less'
import HotSvg from './hotIcon'
import Icon from '@ant-design/icons'

const HotIcons = props => <Icon component={HotSvg} {...props} />

const Title = ({ theme }) => {
  return (
    <div
      style={{ backgroundColor: theme.shopInfoBoxBg }}
      className={style.title}
    >
      <div style={{ color: theme.moduleTitle }} className={style.left}>
        最近动态
      </div>
      <div style={{ color: theme.themeColor }} className={style.right}>
        按热度<HotIcons
          style={{ color: theme.themeColor, width: 12, height: 12 }}
        />
      </div>
    </div>
  )
}

export default Title
